var map = {
	"./": 116,
	"./App": 94,
	"./App.css": 214,
	"./App.test": 215,
	"./App.test.tsx": 215,
	"./App.tsx": 94,
	"./Child": 14,
	"./Child.module.css": 12,
	"./Child.tsx": 14,
	"./Code": 54,
	"./Code.module.css": 115,
	"./Code.tsx": 54,
	"./ColoringImage": 65,
	"./ColoringImage.module.css": 202,
	"./ColoringImage.tsx": 65,
	"./Elementary": 142,
	"./Elementary.module.css": 15,
	"./Elementary.tsx": 142,
	"./ElementaryBeeBadge_fi": 315,
	"./ElementaryBeeBadge_fi.tsx": 315,
	"./ElementaryBeeBadge_sv": 316,
	"./ElementaryBeeBadge_sv.tsx": 316,
	"./ElementaryBreadRecipe_fi": 317,
	"./ElementaryBreadRecipe_fi.tsx": 317,
	"./ElementaryBreadRecipe_sv": 318,
	"./ElementaryBreadRecipe_sv.tsx": 318,
	"./ElementaryCode_fi": 319,
	"./ElementaryCode_fi.tsx": 319,
	"./ElementaryCode_sv": 320,
	"./ElementaryCode_sv.tsx": 320,
	"./ElementaryIntro_fi": 321,
	"./ElementaryIntro_fi.tsx": 321,
	"./ElementaryIntro_sv": 322,
	"./ElementaryIntro_sv.tsx": 322,
	"./ElementaryLottaPin_fi": 323,
	"./ElementaryLottaPin_fi.tsx": 323,
	"./ElementaryLottaPin_sv": 324,
	"./ElementaryLottaPin_sv.tsx": 324,
	"./ElementaryMailPile_fi": 325,
	"./ElementaryMailPile_fi.tsx": 325,
	"./ElementaryMailPile_sv": 326,
	"./ElementaryMailPile_sv.tsx": 326,
	"./ElementarySkiBadge_fi": 327,
	"./ElementarySkiBadge_fi.tsx": 327,
	"./ElementarySkiBadge_sv": 328,
	"./ElementarySkiBadge_sv.tsx": 328,
	"./ElementaryTheatrePermit_fi": 329,
	"./ElementaryTheatrePermit_fi.tsx": 329,
	"./ElementaryTheatrePermit_sv": 330,
	"./ElementaryTheatrePermit_sv.tsx": 330,
	"./Elementary_fi": 331,
	"./Elementary_fi.tsx": 331,
	"./Elementary_sv": 332,
	"./Elementary_sv.tsx": 332,
	"./Highschool": 143,
	"./Highschool.module.css": 21,
	"./Highschool.tsx": 143,
	"./HighschoolBeeBadge_fi": 333,
	"./HighschoolBeeBadge_fi.tsx": 333,
	"./HighschoolBeeBadge_sv": 334,
	"./HighschoolBeeBadge_sv.tsx": 334,
	"./HighschoolBreadRecipe_fi": 335,
	"./HighschoolBreadRecipe_fi.tsx": 335,
	"./HighschoolBreadRecipe_sv": 336,
	"./HighschoolBreadRecipe_sv.tsx": 336,
	"./HighschoolLottaPin_fi": 337,
	"./HighschoolLottaPin_fi.tsx": 337,
	"./HighschoolLottaPin_sv": 338,
	"./HighschoolLottaPin_sv.tsx": 338,
	"./HighschoolMailPile_fi": 339,
	"./HighschoolMailPile_fi.tsx": 339,
	"./HighschoolMailPile_sv": 340,
	"./HighschoolMailPile_sv.tsx": 340,
	"./HighschoolSkiBadge_fi": 341,
	"./HighschoolSkiBadge_fi.tsx": 341,
	"./HighschoolSkiBadge_sv": 342,
	"./HighschoolSkiBadge_sv.tsx": 342,
	"./HighschoolTheatrePermit_fi": 343,
	"./HighschoolTheatrePermit_fi.tsx": 343,
	"./HighschoolTheatrePermit_sv": 344,
	"./HighschoolTheatrePermit_sv.tsx": 344,
	"./Highschool_fi": 345,
	"./Highschool_fi.tsx": 345,
	"./Highschool_sv": 346,
	"./Highschool_sv.tsx": 346,
	"./Info": 144,
	"./Info.module.css": 785,
	"./Info.tsx": 144,
	"./Info_fi": 347,
	"./Info_fi.tsx": 347,
	"./Info_sv": 348,
	"./Info_sv.tsx": 348,
	"./Kindergarten": 145,
	"./Kindergarten.module.css": 17,
	"./Kindergarten.tsx": 145,
	"./KindergartenBeeBadge_fi": 349,
	"./KindergartenBeeBadge_fi.tsx": 349,
	"./KindergartenBeeBadge_sv": 350,
	"./KindergartenBeeBadge_sv.tsx": 350,
	"./KindergartenBreadRecipe_fi": 351,
	"./KindergartenBreadRecipe_fi.tsx": 351,
	"./KindergartenBreadRecipe_sv": 352,
	"./KindergartenBreadRecipe_sv.tsx": 352,
	"./KindergartenCode_fi": 353,
	"./KindergartenCode_fi.tsx": 353,
	"./KindergartenCode_sv": 354,
	"./KindergartenCode_sv.tsx": 354,
	"./KindergartenIntro_fi": 355,
	"./KindergartenIntro_fi.tsx": 355,
	"./KindergartenIntro_sv": 356,
	"./KindergartenIntro_sv.tsx": 356,
	"./KindergartenMailPile_fi": 357,
	"./KindergartenMailPile_fi.tsx": 357,
	"./KindergartenMailPile_sv": 358,
	"./KindergartenMailPile_sv.tsx": 358,
	"./KindergartenSkiBadge_fi": 359,
	"./KindergartenSkiBadge_fi.tsx": 359,
	"./KindergartenSkiBadge_sv": 360,
	"./KindergartenSkiBadge_sv.tsx": 360,
	"./KindergartenTheatrePermit_fi": 361,
	"./KindergartenTheatrePermit_fi.tsx": 361,
	"./KindergartenTheatrePermit_sv": 362,
	"./KindergartenTheatrePermit_sv.tsx": 362,
	"./Kindergarten_fi": 363,
	"./Kindergarten_fi.tsx": 363,
	"./Kindergarten_sv": 364,
	"./Kindergarten_sv.tsx": 364,
	"./Lotta": 146,
	"./Lotta.module.scss": 13,
	"./Lotta.tsx": 146,
	"./PrintButton": 76,
	"./PrintButton.tsx": 76,
	"./Welcome": 147,
	"./Welcome.module.css": 786,
	"./Welcome.tsx": 147,
	"./Welcome_fi": 365,
	"./Welcome_fi.tsx": 365,
	"./Welcome_sv": 366,
	"./Welcome_sv.tsx": 366,
	"./background.jpg": 787,
	"./background.png": 788,
	"./background_1920.jpg": 789,
	"./background_1920.png": 790,
	"./background_320.jpg": 791,
	"./background_320.png": 792,
	"./background_768.jpg": 793,
	"./background_768.png": 794,
	"./bee_badge.png": 24,
	"./bread_recipe.png": 25,
	"./coloring_girl.png": 42,
	"./coloring_girl_color.jpg": 62,
	"./coloring_mouse.png": 43,
	"./coloring_mouse_color.jpg": 63,
	"./coloring_squirrel.png": 44,
	"./coloring_squirrel_color.jpg": 64,
	"./encrypt": 367,
	"./encrypt.js": 367,
	"./index": 116,
	"./index.css": 212,
	"./index.tsx": 116,
	"./letter.jpg": 36,
	"./letter_transcript.png": 37,
	"./logo.jpg": 205,
	"./lotat.jpg": 112,
	"./lotta_museum.png": 204,
	"./lotta_pin.png": 34,
	"./mail_pile.png": 79,
	"./military_mail.png": 35,
	"./operatellus.jpg": 203,
	"./react-app-env.d": 368,
	"./react-app-env.d.ts": 368,
	"./setupTests": 369,
	"./setupTests.ts": 369,
	"./ski_badge.png": 23,
	"./suitcase_closed.jpg": 77,
	"./suitcase_open.jpg": 78,
	"./theatre_permit.png": 26,
	"./translate": 1,
	"./translate.ts": 1
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 402;